// Do not sort these, they are expected to be in a certain order. And changing that order concerns me
export const ORG_MANAGEMENT = 'org_management';
export const ACTIVATION = 'activation';
export const BILLING = 'billing';
export const BILLING_VISIBLE = 'billing_visible';
export const CHANGEPLAN = 'changeplan';
export const DEACTIVATE = 'deactivate';
export const SBCONFIG = 'sbconfig';
export const SBTUNNEL = 'sbtunnel';
